import { APPROVALS_CANCEL_REVIEW_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import {
	type ApprovalsWriteExperience,
	useApprovalsWriteExperience,
} from './useApprovalsWriteExperience.ts';

/**
 * Tracks `approvals/cancel-review` — a pending review was cancelled. A failure here strands
 * the page in review with no way out.
 */
export const useCancelReviewExperience = (): ApprovalsWriteExperience =>
	useApprovalsWriteExperience(APPROVALS_CANCEL_REVIEW_EXPERIENCE);
